import SearchableSelect from '../../../components/ui/SearchableSelect/SearchableSelect';
import { SELECT_MODE } from '../../../components/ui/SearchableSelect/constants';

export default function LicenseSearchableSelect({ sx, slotProps, ...props }) {
  return (
    <SearchableSelect
      {...props}
      mode={props.mode || SELECT_MODE.STATIC}
      size={props.size || 'small'}
      sx={sx}
      slotProps={{
        paper: {
          sx: {
            mt: 0.5,
            borderRadius: 2,
          },
        },
        ...slotProps,
      }}
    />
  );
}
